import AttendeePersonaProps from 'owa-readwrite-recipient-well-fabric/lib/store/schema/AttendeePersonaProps';
import AttendeeType from 'owa-service/lib/contract/AttendeeType';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { isValidSmtpAddress } from 'owa-recipient-email-address/lib/utils/isValidRecipientAddress';
import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';

export function convertRecipientsToAttendees(
    recipients: ReadWriteRecipientViewState[]
): AttendeePersonaProps[] {
    return recipients
        ? recipients.map(
              recipient =>
                  <AttendeePersonaProps>{
                      Mailbox: recipient.persona.EmailAddress,
                      persona: recipient.persona,
                  }
          )
        : [];
}

export function convertAttendeesToEmailAddressWrappers(
    attendees: AttendeeType[]
): EmailAddressWrapper[] {
    return attendees ? attendees.map(attendee => attendee.Mailbox) : [];
}

export function convertAttendeesToRecipientWellViewStates(
    attendees: AttendeePersonaProps[]
): ReadWriteRecipientViewState[] {
    return attendees
        ? attendees.map(attendee => {
              const persona = attendee.persona
                  ? attendee.persona
                  : {
                        EmailAddress: attendee.Mailbox,
                        PersonaId: {
                            // Recipient well code uses the PersonaId.Id in its logic.
                            // We need to pass some Id for it, otherwise it will break its deduplication logic
                            Id: attendee.Mailbox.EmailAddress,
                        },
                    };
              const emailAddress = persona.EmailAddress;
              return {
                  persona: persona,
                  isValid: isValidSmtpAddress(emailAddress.EmailAddress),
                  isSelected: false,
                  isEditing: false,
                  isFadedOut: false,
                  isExpanding: false,
                  isContextMenuOpen: false,
                  displayText: emailAddress.Name ? emailAddress.Name : emailAddress.EmailAddress,
              } as ReadWriteRecipientViewState;
          })
        : [];
}
